import * as React from "react";
import { noop } from "lodash";
import { RouteComponentProps } from "react-router";
import {
  ScrollableDialog,
  HeaderArea,
  ActionText,
  BottomBar,
  ProductLogo,
  Paragraph,
  Size,
  TextColor,
  Grid,
  GridSpacing,
  RowCol,
  Color,
  IconName,
  Button,
  TextAlignment,
  Formsy,
  Stretch,
  PrimaryButton,
  Space,
  ButtonSize,
} from "@root/shared";
import { LoginUrlHelper } from "../login/utils/login-url-helper";
import { findDOMNode } from "react-dom";
import * as PageTimer from "@root/shared/page-timer";
const styles = require("./github-app.scss");

declare const window: Window & {
  initProps: {
    message: string | null;
  };
};

const urls = LoginUrlHelper.buildReturnUrls(window.location.search, {});

export class GitHubLoginShell extends React.Component<RouteComponentProps<{}, { isSignup: boolean; errorMessage: string | null }>> {
  public state = { isSignup: !window.initProps.message, errorMessage: window.initProps.message };

  private emailInput!: HTMLInputElement;
  private passwordInput!: HTMLInputElement;

  private validateForm = (model: { email: string; password: string }) => {
    if (!model.email && !model.password) {
      this.emailInput.focus();
      this.setState({
        errorMessage: "Email and password are required.",
      });
    } else if (!model.email) {
      this.emailInput.focus();
      this.setState({
        errorMessage: "Email or username is required.",
      });
    } else if (!model.password) {
      this.passwordInput.focus();
      this.setState({
        errorMessage: "Password is required.",
      });
    }
  };

  public render() {
    const { isSignup, errorMessage } = this.state;
    const subtitleLink = isSignup ? (
      <>
        Already have an account?{" "}
        <ActionText size={Size.Medium} onClick={() => this.setState({ isSignup: false })}>
          Sign in
        </ActionText>
      </>
    ) : (
      <>
        New to App Center?{" "}
        <ActionText size={Size.Medium} onClick={() => this.setState({ isSignup: true })}>
          Sign up
        </ActionText>
      </>
    );

    const footerLink = isSignup ? (
      <>
        By creating an account you accept our <a href="https://azure.microsoft.com/en-us/support/legal">Terms of use</a> and{" "}
        <a href="https://aka.ms/appcenterprivacy">Privacy policy</a>.
      </>
    ) : (
      <>
        Your account is subject to our <a href="https://azure.microsoft.com/en-us/support/legal">Terms of use</a> and{" "}
        <a href="https://aka.ms/appcenterprivacy">Privacy policy</a>.
      </>
    );

    return (
      <PageTimer.Collector>
        <div className={styles.background}>
          <ProductLogo invert />
          <ScrollableDialog
            visible
            onRequestClose={noop}
            willChangeHeight
            header={
              <HeaderArea
                smallSubtitle
                title={isSignup ? "Sign up" : "Sign in"}
                subtitle={(SubtitleText) => <SubtitleText>{subtitleLink}</SubtitleText>}
              />
            }
            bottomBar={
              <BottomBar autoHeight>
                <Paragraph size={Size.Medium} color={TextColor.Secondary}>
                  {footerLink}
                </Paragraph>
              </BottomBar>
            }
          >
            <Formsy.Form
              method="post"
              className={errorMessage ? styles.signupContainer : styles.signupContainerWithRoomForErrorMessage}
              onInvalidSubmit={this.validateForm}
              onValidSubmit={(_, __, ___, submit) => submit()}
            >
              <Grid rowSpacing={GridSpacing.XSmall}>
                <RowCol>
                  <Grid rowSpacing={GridSpacing.XXSmall} className={styles.buttons}>
                    <RowCol>
                      <Button color={Color.Black} icon={IconName.GitHub} href={urls.github}>
                        GitHub
                      </Button>
                    </RowCol>
                    <RowCol>
                      <Button color={Color.Black} icon={IconName.Microsoft} href={urls.aad} className={styles.microsoftButton}>
                        Microsoft
                      </Button>
                    </RowCol>
                    <RowCol>
                      <Button icon={IconName.Google} href={urls.google}>
                        Google
                      </Button>
                    </RowCol>
                  </Grid>
                </RowCol>
                {!isSignup ? (
                  <>
                    <RowCol>
                      <Paragraph align={TextAlignment.Center} size={Size.Medium} color={TextColor.Secondary}>
                        or
                      </Paragraph>
                    </RowCol>
                    <RowCol>
                      <Formsy.Input
                        ref={(x) => (this.emailInput = findDOMNode(x) as HTMLInputElement)}
                        autoFocus
                        name="email"
                        type="text"
                        autoCorrect="none"
                        autoCapitalize="none"
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="Email or username"
                        isRequired
                      />
                    </RowCol>
                    <RowCol>
                      <Formsy.Input
                        ref={(x) => (this.passwordInput = findDOMNode(x) as HTMLInputElement)}
                        name="password"
                        type="password"
                        placeholder="Password"
                        isRequired
                        data-test-id="login-input-password"
                      />
                      {errorMessage ? (
                        <Paragraph spaceAbove={Space.XXSmall} size={Size.Small} color={TextColor.Error}>
                          {errorMessage}
                        </Paragraph>
                      ) : null}
                    </RowCol>
                    <RowCol>
                      <Stretch centered>
                        <Paragraph size={Size.Medium}>
                          <a href="/reset" target="_blank">
                            Forgot password?
                          </a>
                        </Paragraph>
                        <PrimaryButton size={ButtonSize.Small} type="submit">
                          Sign in
                        </PrimaryButton>
                      </Stretch>
                    </RowCol>
                  </>
                ) : null}
              </Grid>
            </Formsy.Form>
          </ScrollableDialog>
        </div>
      </PageTimer.Collector>
    );
  }
}
